module.exports = __webpack_public_path__ + "static/media/tablet.c7752b08.png";